import axios from "../config/axiosInstance";
import endpoints from "./endpoints";

export const getProductSalesReports = async (details) => {
  const response = await axios.put(
    endpoints.getProductSalesReportsURL,
    details
  );
  return response;
};